export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook('apollo:error', (error: Error) => {
    const gqlErrors = error?.graphQLErrors?.filter(({ message }) => message !== 'PersistedQueryNotFound')

    // console.dir(error, { depth: null })

    if (gqlErrors?.length > 0) {
      error?.graphQLErrors?.forEach((err) => {
        console.error(err.message)
      })
      console.dir(error, { depth: 4 })
    }

    // Handle different error cases
  })
})
